<template>
<div class="panobox">
   <!-- 加载条 begin-->
   <div class="vrloading loadingTopbox wrap " v-show="!isLoadOk">
       <div class="loadingOutside">
          <div class="loadingOked"></div>
          <p>正在玩命加载中...</p>
       </div>
   </div>
   <!-- 加载条 end-->

   <!-- 封面 begin-->
   <div class="vrBoxFm wrap"  v-show="pageState=='showtips' || pageState=='beginLoad'">
       <div class="pagebjbox_load pos_abs"></div>
       <div class="btnbox">
           <img src="../assets/images/ewm.png" class="page1ewm  animated fadeInUp">
           <p>请使用微信或微博APP扫码参与互动</p>
       </div>
   </div>
   <!-- 封面 end-->




</div>
</template>


<script>
import globalVar from '@/api/global_variable'
export default {
  name: 'Home',
  components: {
    
  },
  data () {
    return {
      isLoadOk:true,
      pageState:'beginLoad',
      getUrlPar:{
        gettype:0,
        typeid:1,
        page:1,
        size:5
      },
      pageNum:0,
      loading: false,
      finished: false,
      nowTime:parseInt(new Date().getTime()/1000),
      isshow:true,
    }
  },
  filters: {
      formatDate: function (value) {
        let date = new Date(value*1000);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      },
      imgHandle:function(url){
        //console.log(globalVar);
        if(url){
          let urlstr=globalVar.imgHandle(url);
          return urlstr;
        }
      }
  },
  mounted () {
    //this.loadPano();
    //this.getMenuData();
   // this.share();
  },
  methods:{
    share(){
        let shareDataObj={
        　　　　title: '', // 分享标题
        　　　　desc: '', // 分享描述
        　　　　link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        　　　　imgUrl: '', // 分享图标
                success: function () {          
                  console.log("");
         　　　 }
        }
        this.Share.wx(shareDataObj)
    },
    showtips(){
      let isPc=globalVar.isPc();
      if(isPc){
         this.closeTips();
      }else{
        this.pageState="showtips"
      }
    },
    closeTips(){
      //关闭提示
      //this.pageState='showPano'
       this.$router.push({ path: '/Vrbox'});
    },
  }
}
</script>

<style>
.page1ewm{ width: 3.6rem }
.vrloading{ display: flex; justify-content: center; align-items: center; font-size: 0.28rem; }
.loadingOutside{    width: 70%;
    height: 0.16rem;
    border-radius: 0.5rem;
    background-color: #fff; }
.loadingOutside  p{    text-align: center;
    padding-top: 0.1rem;}
.loadingOked {    width: 10%;
    height: 0.16rem;
    background-color: #e80707;
    border-radius: 0.5rem;}
    .vrfmbj{ width: 7.5rem;    height: 100%; }
    .pos_abs{ position: absolute; z-index: 5 }
    .vrfmlogo{ width: 2.62rem;    top: 0.3rem;
    left: 0.2rem; }
    .page1_btn{     width: 2.21rem;
    height: 0.55rem;
    top: 5.3rem;
    left: 2.8rem; animation-delay: .5s; -webkit-animation-delay: .5s; }
 /*    .page1_slog{ width: 6.84rem;top: 2.7rem;left: 0.7rem;} */
    .game_gz{ width: 100%; height: 8.15rem; top:1.5rem; left: 0rem; }
    .outsideBox{     position: relative;
    width: 7.5rem;
    margin: 0 auto; }
    .btn_close{     top: 8.7rem;
    left: 3.4rem;
    width: 0.71rem;}
    .gameTips p{         width: 4.5rem;
    max-height: 2rem;
    margin: 0 auto;
    font-size: 0.32rem;
    top: 3rem;
    line-height: 0.6rem;
    text-indent: 2em;
    color: #fff;
    position: absolute;}
    .pagebjbox_load{ width:100%; height: 100vh; background: url('../assets/images/page1_bj.jpg'); 
      opacity: 0.9; background-size: cover; z-index: 3 }
      .btnbox{ width: 100%; height: 100vh; display: flex; justify-content: center; align-items: center; position: fixed; top:0; left:0; flex-direction: column;
    z-index: 99;} 
    .btnbox p{ font-size: 0.28rem; color: #fff; line-height: 0.5rem }
    .page1slog{width: 3.2rem; ;}
    .page1btn{ width: 2.21rem; height: 0.55rem;}

/* .topbox{ width: 100%; height: 100%; background-color: rgba(0,0,0,0.8); } */
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue